export function createBeforeFormLoadEvent() {
    return new CustomEvent("d365mkt-beforeformload", { bubbles: true });
}
